import { faRocket } from "@fortawesome/pro-regular-svg-icons";

import { Pill } from "src/base-components/Pill";
import { Tooltip, TooltipProps } from "src/design-system/Tooltip";

type BetaPillProps = Omit<TooltipProps, "children">;

export const BetaPill: React.FC<BetaPillProps> = ({
  title = "Beta feature 🎉",
  body = BETA_PILL_BODY_TEXTS.feature,
  ...props
}) => {
  return (
    <Tooltip body={body} title={title} {...props}>
      <Pill size="sm">
        <Pill.Icon icon={faRocket} />
        <Pill.Text>Beta</Pill.Text>
      </Pill>
    </Tooltip>
  );
};

export const BETA_PILL_BODY_TEXTS = {
  feature:
    "This feature has been recently developed and your feedback is crucial as we continue to refine our products to better serve your needs.",
  connection:
    "This connection has been recently integrated and your feedback is crucial as we continue to refine our products to better serve your needs.",
};
